import { BaseService, RequestType } from "@intech/react-service";
import { MensagemEntidade } from "../entidades/MensagemEntidade";

class Mensagem extends BaseService {

  constructor() {
    super("mensagem");
  }

  BuscarTodas = () =>
    this.CreateRequest<Array<MensagemEntidade>>(RequestType.GET);

  BuscarPorFundacaoEmpresaPlano = (fundacao: string, empresa: string, plano: string) =>
    this.CreateRequest<Array<MensagemEntidade>>(RequestType.GET, `porFundacaoEmpresaPlano/${fundacao}/${empresa}/${plano}`);

  BuscarPorPlano = (plano: string) =>
    this.CreateRequest<Array<MensagemEntidade>>(RequestType.GET, `porPlano/${plano}`);

  EnviarMensagem = (data: any) =>
    this.CreateRequest<string>(RequestType.POST, `/`, data);

}

export const MensagemService = new Mensagem();